export default __webpack_public_path__ + "static/media/icons-delete.81830018.svg";